import {
  allSmartCallFlowCallActionTypes,
  type ISmartCallFlowAction,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type.ts'

export const hasCallActions = (
  id: string,
  getActionById: (id: string) => ISmartCallFlowAction | undefined
): boolean => {
  const action = getActionById(id)
  if (!action) return false
  if (allSmartCallFlowCallActionTypes.includes(action.actionStore.type)) {
    return true
  } else {
    return action.actionStore.nextIds.some((id) => hasCallActions(id, getActionById))
  }
}
